<template>
    <div class="row">
        <div :class="{'col-lg-12': !selectedType, 'col-lg-4': selectedType}">
            <div class="g-table-wrapper">
                <div class="table-title">
                    Budgetlinjer
                </div>

                <vue-good-table
                    :key="tableKey"
                    :columns="columns"
                    :rows="filteredRows"
                    :search-options="searchOptions"
                    :pagination-options="paginationOptions"
                    :sort-options="sortOptions"
                    :styleClass="styleClass"
                    @on-row-click="selectType"
                    :row-style-class="selectedRowClass"
                    v-if="!loading"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props" :class="{'selected': selectedType && (selectedType.name === props.row.name)}">
                        <div v-if="props.column.field == 'description'" class="table-column__description" :title="props.row.description">
                            {{ props.row.description }}
                        </div>
                        <div v-else-if="props.column.field == 'proposal_cost'" style="text-align:left;">
                            {{ props.row.proposal_cost | currency }}
                        </div>
                        <div v-else-if="props.column.field == 'expended_cost'" style="text-align:left;">
                            {{ props.row.expended_cost | currency }}
                        </div>
                        <div v-else-if="props.column.field == 'difference'" style="text-align:left;" :class="{'good': (props.row.proposal_cost - props.row.expended_cost) > 0, 'bad': (props.row.proposal_cost - props.row.expended_cost) < 0}">
                            <span v-if="(props.row.proposal_cost - props.row.expended_cost) > 0">+</span>{{ props.row.proposal_cost - props.row.expended_cost | currency }}
                        </div>
                        <div v-else-if="props.column.field == 'paid'" style="text-align:left;">
                            <span v-if="props.row.paid">
                                Betalt
                            </span>
                            <span v-else>
                                Ikke betalt
                            </span>
                        </div>
                        <div v-else-if="props.column.field == 'minuba_external_id'">
                            <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                                <i class="fas fa-eye"></i>
                            </a>
                        </div>
                        <div v-else :title="props.formattedRow[props.column.field]">
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>   

                <box-loading height="350" v-else />
            </div>
        </div>
        <div class="col-lg-8" v-if="selectedType">
            <div v-if="selectedType">
                <div style="margin-bottom:5px;">
                    <a href="javascript:void(0)" @click="selectedType = null; tableKey = 0" style="text-decoration:none;color:#172b43;font-weight:600;">
                        <i class="far fa-times" /> Luk
                    </a>
                </div>
            </div>
            <minuba-budget-report-linetypes-projecttypes :type="selectedType.name" :rows="selectedType.project_types"></minuba-budget-report-linetypes-projecttypes>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['rows', 'loading'],
        data () {
            return {
                tableKey: 0,
                selectedType: null,
                columns: [
                    { label: 'Type', field: 'name', type: 'string', width: '30%', align: 'left', sortable: true },
                    { label: 'Budgetteret', field: 'proposal_cost', type: 'number', width: '20%', align: 'left', sortable: true },
                    { label: 'Realiseret', field: 'expended_cost', type: 'number', width: '20%', align: 'left', sortable: true },
                    { label: 'Difference', field: 'difference', type: 'number', width: '20%', align: 'left', sortable: true }
                ],
                searchOptions: {
                    enabled: true,
                    trigger: 'enter',
                    placeholder: 'Søg og tryk enter ...',
                    skipDiacritics: true
                },
                paginationOptions: {
                    enabled: true,
                    perPage: 30,
                    rowsPerPageLabel: 'Rækker pr. side',
                    allLabel: 'Alle',
                    nextLabel: 'Næste',
                    prevLabel: 'Forrige',
                    ofLabel: 'af',
                    pageLabel: 'side'
                },
                sortOptions: {
                    enabled: true,
                    initialSortBy: {
                        field: 'difference',
                        type: 'desc'
                    }
                },
                styleClass: 'vgt-table',
                params: {}
            }
        },
        methods: {
            selectType (params) {
                this.selectedType = params.row
                this.tableKey++
            },
            selectedRowClass (row) {
                if (this.selectedType && this.selectedType.name === row.name) {
                    return 'selected'
                }
                return ''
            }
        },
        components: {
            'minuba-budget-report-linetypes-projecttypes': require('./minubaBudgetLineTypesProjectTypes.vue')
        },
        computed: {
            filteredRows () {
                if (this.rows.length) {
                    return this.rows
                }
                return []
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .good, .bad {
        font-weight: 700;
    }

    .good, .good span {
        color: $color--good !important;
    }

    .bad, .bad span {
        color: $color--bad !important;
    }

</style>



// WEBPACK FOOTER //
// minubaBudgetLineTypes.vue?fdea0460